import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import UserDetailsCard from "../../admin/components/report/UserDetailsCard";

const UserDetails = ({ token, distributor }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!distributor || !distributor.user_detail) {
            history.push('/distributor')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <UserDetailsCard
                        role="distributor"
                        token={token}
                        country={distributor.country}
                        stampSetting={distributor.stamp}
                        tokenSetting={distributor.token}
                        pointSetting={distributor.loyalty_point}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(UserDetails);
